module.exports = __webpack_public_path__ + "static/media/inventoryAptAutobook.f95687fa.svg";